export default __webpack_public_path__ + "static/Giant_Bee_Honey-76e2a814bb219f9ea01739c67ed7d3ee.png";